import { render, staticRenderFns } from "./WorkHeading.vue?vue&type=template&id=044cb8a0&lang=pug&"
import script from "./WorkHeading.vue?vue&type=script&lang=js&"
export * from "./WorkHeading.vue?vue&type=script&lang=js&"
import style0 from "./WorkHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports